export const GlobalLoader = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="animate-spin rounded-full border-t-4 border-blue-500 w-16 h-16"></div>
    </div>
  );
};
